export var showLogic = {
    result: 'visible',
};
export var showLogicBoolean = {
    result: true,
};
